'use client';

import Link from "next/link";
import { usePathname, useSearchParams } from "next/navigation";
import { Home, Grid3X3, Search, Sparkles } from "lucide-react";

const items = [
  { href: "/", label: "Home", icon: Home },
  { href: "/tools?view=categories", label: "Categories", icon: Grid3X3 },
  { href: "/tools?search=1", label: "Search", icon: Search },
  { href: "/tools?sort=popular", label: "Popular", icon: Sparkles },
];

export function MobileBottomNav() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  return (
    <nav className="fixed inset-x-0 bottom-0 z-40 border-t border-slate-200 bg-white/95 px-4 py-2 shadow-[0_-8px_30px_rgba(15,23,42,0.12)] backdrop-blur-md dark:border-slate-800 dark:bg-slate-950/95 md:hidden">
      <div className="mx-auto flex max-w-md items-center justify-between gap-1">
        {items.map((item) => {
          const Icon = item.icon;
          const url = new URL(item.href, 'http://localhost');
          const itemPath = url.pathname;
          const itemSearchParams = new URLSearchParams(url.search);

          let active = false;

          if (item.href === "/") {
            active = pathname === "/";
          } else if (itemPath === "/tools") {
            // For tools navigation, check if we're on the tools page and the query params match
            active = pathname === "/tools";

            // Check specific query parameters
            if (active) {
              const currentView = searchParams.get('view');
              const currentSearch = searchParams.get('search');
              const currentSort = searchParams.get('sort');

              if (itemSearchParams.get('view') === 'categories') {
                active = currentView === 'categories';
              } else if (itemSearchParams.get('search') === '1') {
                active = currentSearch === '1' || currentSearch !== null;
              } else if (itemSearchParams.get('sort') === 'popular') {
                active = currentSort === 'popular';
              }
            }
          }

          return (
            <Link
              key={item.href}
              href={item.href}
              className={`flex flex-1 flex-col items-center gap-1 rounded-2xl px-2 py-1 text-[11px] font-medium transition ${active
                  ? "bg-slate-900 text-white shadow-sm dark:bg-slate-100 dark:text-slate-900"
                  : "text-slate-500 hover:bg-slate-100 hover:text-slate-900 dark:text-slate-400 dark:hover:bg-slate-900 dark:hover:text-slate-100"
                }`}
            >
              <Icon className="h-4 w-4" />
              <span>{item.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}

